import { Globe } from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';

type FlagProps = SVGProps<SVGSVGElement> & { className?: string };

/**
 * 24x16 SVG flags. Add new ones here and they're picked up automatically
 * by getFlag(code) below.
 */
// preserveAspectRatio="xMidYMid slice" makes the flag fill any container
// (square or otherwise) with centre-crop instead of letterboxing — ideal
// when rendered inside a round button.
export function FrFlag(props: FlagProps) {
  return (
    <svg
      viewBox="0 0 3 2"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <rect width="1" height="2" x="0" fill="#0055A4" />
      <rect width="1" height="2" x="1" fill="#FFFFFF" />
      <rect width="1" height="2" x="2" fill="#EF4135" />
    </svg>
  );
}

export function GbFlag(props: FlagProps) {
  return (
    <svg
      viewBox="0 0 60 30"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <clipPath id="gbflag-t">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <rect width="60" height="30" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFF" strokeWidth="6" />
      <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#gbflag-t)" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 v30 M0,15 h60" stroke="#FFF" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}

const flagMap: Record<string, ComponentType<FlagProps>> = {
  fr: FrFlag,
  gb: GbFlag,
};

export function getFlag(code: string | undefined | null): ComponentType<FlagProps> {
  const c = (code ?? '').toLowerCase();
  return flagMap[c] ?? Globe;
}

export const SUPPORTED_FLAG_CODES = Object.keys(flagMap);
